import { ComponentType } from 'react';

import { Button } from 'components/Form/Button';

export type ButtonActionProps<T> = {
  type: 'button';
  label: string;
  onClick: (items: Array<T>) => void;
  analyticsId: string;
  icon: ComponentType<any>;
};

export function ButtonAction(props: { action: ButtonActionProps<any>; selectedItems: Array<any> }) {
  return (
    <Button
      analyticsId={props.action.analyticsId}
      className="mr-2"
      variant="secondary"
      RightIcon={props.action.icon}
      onClick={() => props.action.onClick(props.selectedItems)}
    >
      {props.action.label}
    </Button>
  );
}
